import { useCheckAccessClick, useNavigateToAura } from "@/src/hooks";

import { I18nUtil } from "@utils";
import { AppImage } from "@/src/components/NextImage";
import { ShellLink } from "@/src/components";
import Translations from "@translate/components/discover/Discover";

const I18n = I18nUtil.createScoped(Translations);

export const Discover = () => {
  const { navigateToAura } = useNavigateToAura();
  const { handleAccessClick } = useCheckAccessClick({
    originClick: navigateToAura,
  });
  const discoverList = [
    {
      title: I18n.t("Start Earning Aura Now"),
      description: I18n.t(
        "Turn tweets into rewards and level up Edgen's AI: your quick-start guide.",
      ),
      image: "/assets/images/home_image_d_aura.webp",
      link: "",
      onClick: handleAccessClick,
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <h2
        aria-label="Discover h2"
        data-openreplay-label="Discover h2 Semantic"
        id="sem-discover-h2"
        className="headline_regular_s text-content_primary"
      >
        {I18n.t("Discover More")}
      </h2>
      <div className="flex flex-col md:flex-row gap-6 md:justify-between">
        {discoverList.map((item) => {
          const Tag = item.link ? ShellLink : "div";
          const params = item.link
            ? { href: item.link }
            : ({} as { href: string });
          return (
            <Tag
              data-openreplay-label="discover · Discover · Tag"
              key={item.title}
              onClick={item.onClick}
              className="flex flex-col flex-1 cursor-pointer relative"
              {...params}
            >
              <AppImage
                src={item.image}
                alt={item.title}
                width={358}
                height={202}
                className="rounded-3 overflow-hidden object-cover w-full h-auto md:w-[358px] md:h-[202px]"
              />
              <div className="absolute bottom-0 pl-4.5 pb-4.5 pr-3.5">
                <p className="title_l text-content_primary">{item.title}</p>
                <p className="body_m text-content_secondary mt-2">
                  {item.description}
                </p>
              </div>
            </Tag>
          );
        })}
      </div>
    </div>
  );
};
